TS.ns('WL');
(function () {            
    var kendo = window.kendo,
        ui = kendo.ui,
        Widget = ui.Widget;               

   /* var oldTsDatePicker = ui.TsDatePicker

    ui.TsDatePicker.prototype.init= function(element, options) {
        
        oldTsDatePicker.apply(this, arguments);
        var that = this,
            strVal, date,
            maskFormat;

        strVal = options.value;
        if (TS.isString(strVal)) {
            date = kendo.parseDate(strVal, options.parseFormats, options.culture);
            options.value = date;
        }

        DatePicker.fn.init.call(this, element, options);

        // CP 20140702 - replaced maskedInput plugin with dateEntry
        maskFormat = getMaskFormat(options.format);
        that.element.dateEntry({ dateFormat: maskFormat, spinnerImage: null });

        // prevDatePickerSetup.apply(this, arguments);
    };

    ui.TsDatePicker.prototype = oldTsDatePicker.prototype;
    */

    $.dateEntry._formatDate = function (inst, format) {

        var currentCultureFormat = $.dateEntry.regionalOptions[kendo.culture().name];
        var localFormat = format;
        if (currentCultureFormat)
            localFormat = currentCultureFormat.dateFormat;

        var cultureExtendedFormat = kendo.culture().calendar.patterns.d;
        
        var dayTwoDigitFormat = false, monthTwoDigitFormat = false;

        if (cultureExtendedFormat.toLowerCase().indexOf('dd'))
                dayTwoDigitFormat = true;

        if (cultureExtendedFormat.toLowerCase().indexOf('mm'))
                monthTwoDigitFormat = true;

        var lastChr = cultureExtendedFormat

        var currentDate = '';
        for (var i = 0; i <= inst._lastField; i++) {
            currentDate += (i === 0 ? '' : localFormat.charAt(3));
            var field = localFormat.charAt(i);
            switch (field) {
                case 'y':
                    currentDate += inst._selectedYear;
                    break;
                case 'Y':
                    currentDate += inst._selectedYear % 100;
                    break;
                case 'm':
                    currentDate += (monthTwoDigitFormat === true ? this._formatNumber(inst._selectedMonth + 1) : (inst._selectedMonth + 1));
                    break;
                case 'M':
                        currentDate += (inst._selectedMonth + 1);                    
                    break;
                case 'n': case 'N':
                    currentDate += inst.options[field === 'N' ? 'monthNames' : 'monthNamesShort'][inst._selectedMonth];
                    break;
                case 'd':
                    currentDate += (dayTwoDigitFormat === true ?  this._formatNumber(inst._selectedDay) : currentDate += inst._selectedDay);
                    break;
                case 'D':
                        currentDate += inst._selectedDay;
                    break;
                case 'w': case 'W':
                    currentDate += inst.options[field === 'W' ? 'dayNames' : 'dayNamesShort'][
                        new Date(inst._selectedYear, inst._selectedMonth, inst._selectedDay, 12).getDay()] +
                        ' ' + this._formatNumber(inst._selectedDay);
                    break;
            }
        }
        return currentDate + '.';
    };
})(jQuery);

WL.documentBase = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this;

        me.parent(config);

        var list = me.getDocumentStateList();
        if (list) {
            list.un('selectionChanged', me._onStateChanged, me);
            list.on('selectionChanged', me._onStateChanged, me);
        }
    },

    getDocumentStateList: function () {
        var me = this;
        return me.getDomainProperty('DocumentAllowedTransitionList');
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var warranty = me.vrWarranties_gcWarrantyItemName_Property;
        if (warranty) {
            warranty.on('selectionChanged', me.onWarrantyChanged, me);
        }

        documentWarrantyList = me.getDomainProperty('dgDocumentWarrantyCollection_Property');

        if (documentWarrantyList) {
            documentWarrantyList.getCommand('Add').InternalVisible = me.CanEditGuarantees;
            documentWarrantyList.getCommand('Delete').InternalVisible = me.CanEditGuarantees;
            documentWarrantyList.on('cellBeginEdit', me._onDocumentWarrantyBeginEdit);
        } 

        var stateTransitionList = me.getDomainProperty('dgStateTransitionCollection_Property');
        if (stateTransitionList != null) {            

            me.ImageNumberVisible = ko.computed(function () {
                if (me.ShowTransitionImage())
                    return true;
                return false;
            });

            stateTransitionList.on('cellBeginEdit', me.onStateTransitionListBeginEdit);

            stateTransitionList.getFieldByName('gcImageNumber_Field').renderer = "hyperlinkGrid";
            stateTransitionList.getFieldByName('gcImageNumber_Field').Visible(me.ImageNumberVisible());
            //stateTransitionList.getFieldByName('Selected_Field').Visible(me.ImageNumberVisible() && me.CanViewCompareButton());

            TS.UI.Renderers.grid.smallWrap = {
                getCellClass: function (field, dataItem) {
                    return 'wrap-text';
                }
            };

            TS.UI.Renderers.grid.hyperlinkGrid = {
                getCellClass: function (field, dataItem) {
                    return 'grid-hyperlink';
                }
            };

            //cat = stateTransitionList.Commands;

            //newCmd = new TS.domain.Command();
            //newCmd['Code'] = 'CompareAction';
            //['Text'] = me.CompareActionCommandText;
            //newCmd['handler'] = '_compareOffer';
            //newCmd['IconCode'] = 'list-ol';
            //newCmd.InternalVisible = me.CanViewCompareButton() && me.ImageNumberVisible();

            //cat.push(newCmd);
        }

        var commentList = me.getDomainProperty('dgDocumentCommentCollection_Property');
        if (commentList != null) {
            me.cmdVisibleDelete = ko.computed(function () {
                if (commentList.SelectedItem() == null)
                    return false;
                return WL.Config.DocumentCommentEditability == 'Yes' || (WL.Config.DocumentCommentEditability == 'User-conditioned' && commentList.SelectedItem().UserId() == me.CurrentUserId());
            });
            commentList.getCommand('Delete').InternalVisible = me.cmdVisibleDelete;
            commentList.on('cellBeginEdit', me.onCommentListBeginEdit);
        }

        var warningList = me.getDomainProperty('dgDocumentWarning_Property');
        if (warningList != null) {
            warningList.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.tbody.children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);
                        if (dataItem.MessageTypeStr == "Warning") {
                            row.addClass("warning_yellow_row");
                        }

                        if (dataItem.MessageTypeStr == "Error") {
                            row.addClass("error_red_row");
                        }
                    }
                }
            }
        }
    },

    onStateTransitionListBeginEdit: function (e) {
        var me = this,
            owner = me._Domain,
            stateTransitionList = owner.getDomainProperty('dgStateTransitionCollection_Property');

        if (e.fieldName == 'ImageNumber') {
            e.preventDefault();

            if (stateTransitionList.SelectedItem().ImageId() == null)
                return;

            owner.performServerCommand({
                cmd: 'OpenDocumentImage',
                submitModel: true,
                extraData: { ImageId: stateTransitionList.SelectedItem().ImageId(), ImageSiteId: stateTransitionList.SelectedItem().ImageSiteId() },
                blockUI: false
            });
        }
        else if (e.fieldName == 'Selected') {
            if (stateTransitionList.SelectedItem().ImageId() == null)
                e.preventDefault();
        }
        else if (owner.ReadOnly) {
            e.preventDefault();
        }
    },

    _onDocumentWarrantyBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner();

        if (owner.CanEditGuarantees() == false) {
            e.preventDefault();            
        }
    },

    onCommentListBeginEdit: function (e) {
        var me = this,
            owner = me._Domain,
            commentList = owner.getDomainProperty('dgDocumentCommentCollection_Property');

        if (e.fieldName == 'FreeTxt' && (WL.Config.DocumentCommentEditability == 'Yes' || (WL.Config.DocumentCommentEditability == 'User-conditioned' && commentList.SelectedItem().UserId() == me._Domain.CurrentUserId())))
            return;

        e.preventDefault();
    },

    _onStateChanged: function (e) {
        var me = this;

        me.performServerCommand({
            cmd: 'ChangeDocumentState',
            submitModel: true,
            blockUI: false,
            callback: function (e) {
                if (e.success === false) {
                    me.Document.DocumentStateId(me.Document.OldDocumentStateId());
                    me.Document.DocumentStateName(me.Document.OldDocumentStateName());
                }
                var sl = me['DocumentAllowedTransitionList'];
                sl && sl.invalidateList();
            }
        });
    },

    onWarrantyChanged: function (selectedRecord) {
        var me = this,
            warrantyList = me.getDomainProperty('dgDocumentWarrantyCollection_Property');

        if (selectedRecord.sender.SelectedItem()) {
            warrantyList.SelectedItem().ItemCode(selectedRecord.sender.SelectedItem().ItemCode);
            warrantyList.SelectedItem().SiteId(me.Document.SiteId());
        }
    },

    createCommands: function (config, server) {
        var me = this;
        me.parent(config);

        var cat = me.CommandCategories.Navigation.Commands();

        if (cat != null)
            for (var i = 0; i < cat.length; i++) {;
                if (cat[i].Code == "Reports") {
                    for (var j = 0; j < cat[i].Commands().length; j++) {
                        cat[i].Commands()[j].handler = "_showReport";
                    }
                }
            }
    },

    _showReport: function (e) {
        var me = this;
        me.performServerCommand('Navigation.Reports.' + e.Code, true, null,
            function (r) {
                var me = this;

                if (r.modelData == undefined)
                    return;

                if (!r.modelData.ReportExportIsHtml)
                    return;

                var url = me.rootUrl + '/../Handlers/GetReport.ashx' + "?ReportId=" + r.modelData.ReportExportId + r.modelData.ReportExportParameters;
                window.open(url, '_blank');
            });
    //},

    //_compareOffer: function () {
    //    var me = this;

    //    me.performServerCommand({ cmd: 'CompareOffers', submitModel: true, extraData: {}, blockUI: false });
    }

});
